function loadLawOffices() {
    var location = $("#locations").val();
    var area = $("#areas").val();
    loadPageToCenter("lawoffices?location=" + location + "&area=" + area);
}